export default {
  "content": "<path d=\"M5.896 17.5c-.486 0-.9-.17-1.24-.51a1.69 1.69 0 01-.51-1.24V5.125h-.813v-1.75h4.209V2.5h4.916v.875h4.209v1.75h-.834V15.75c0 .486-.17.9-.51 1.24-.34.34-.754.51-1.24.51H5.896zm8.187-12.375H5.896V15.75h8.187V5.125zM7.458 14h1.75V6.875h-1.75V14zm3.313 0h1.75V6.875h-1.75V14z\" fill=\"currentColor\"/>",
  "attrs": {
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};